export const hanaCategoricalDefault: string[] = [];
export const hanaCategoricalMixed: string[] = [];
